import React from 'react';

const ChapterQuestions = () => {
    return (
        <div></div>
    )
}

export default ChapterQuestions